// Note: We don't use "import" statements here, as they would require
// to check import.meta.webpackHot below for isHmrEnabled check,
// and that's break Jest tests, which do not support ES modules yet.

// eslint-disable-next-line import/no-unassigned-import
import './sentry';

import { isAxiosError } from 'axios';

import { launchClient } from '@dr.pogodin/react-utils/client';

import Application from '../shared';

// TODO: This if() is to prevent a Jest test failure, without spending time
// to properly polyfill the test environment.
if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', (event) => {
    // NOTE: It is not supposed to ever happen, but in the unlucky case I have
    // missed something regarding the auth management, it ensure that if user
    // auth session is lost, the app will reload (and land to the login screen),
    // rather than remain in an inconsistent, semi-broken state. This is a last
    // resort fallback.
    if (isAxiosError(event.reason) && event.reason.status === 401) {
      location.reload();
    }
  });
}

async function start() {
  // As a side-effect it initializes the Firebase & Google.Analytics.
  // TODO: For now it is just disabled for test environment, as it requires
  // to correctly mock stuff there, which makes not sense at the moment, as we
  // don't really have any good test coverage.
  if (process.env.NODE_ENV !== 'test') {
    await import(/* webpackChunkName: "firebase-client-service" */ './services/firebase');
  }

  await launchClient(Application, {
    // With HMR hydration may throw hydration errors in subsequent re-renders.
    dontHydrate: !!import.meta.webpackHot,
  });
}

void start();
